import { useField } from 'formik';
import React, {useMemo} from 'react';
import { Container } from './styles';
import formaters from '../formaters';

import TextField from '@material-ui/core/TextField';

const TextBox = ({
  label = null,
  formater,
  selectedInput,
  options = [],
  mask = null,
  ...props
}) => {
  const [field] = useField(props);
  const transform = useMemo(() =>  (formaters[formater] || formaters._default)(mask), [formater, mask]);

  return <Container>
            <TextField 
            label="Gênero (Opcional)" 
            variant="outlined"  
            inputProps={{style: {fontSize: 15}}} 
            InputLabelProps={{style: {fontSize: 15}}} size="small"
            {...field} {...props} value={transform(field.value)} type={'text'}
            />
        </Container>
}

export default TextBox;
